import { useModalState } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { VerifyOtpDialog } from "@src/appV2/Auth/LoginSignUp/Dialogs";
import { AuthMode } from "@src/appV2/Auth/LoginSignUp/libs";
import { useStepUpAuthContext } from "@src/appV2/Auth/LoginSignUp/StepUpAuth/context";
import { StepUpAuthConfirmationText } from "@src/appV2/Auth/LoginSignUp/StepUpAuth/StepUpAuthConfirmationText";
import { StepUpAuthRequestOtpButton } from "@src/appV2/Auth/LoginSignUp/StepUpAuth/StepUpAuthRequestOtpButton";
import { type APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { PageFooterWrapper } from "@src/appV2/redesign/components/PageFooterWrapper";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { type ReactElement, useRef } from "react";

interface ConfirmPhonePageProps {
  title: string;
  requestOtpEventName: (typeof APP_V2_USER_EVENTS)[keyof typeof APP_V2_USER_EVENTS];
  onCancel?: () => void;
  onSuccess: () => void;
  fallbackGoBackPath?: string;
}

export function ConfirmPhonePage(props: ConfirmPhonePageProps): ReactElement {
  const { title, onCancel, onSuccess, requestOtpEventName, fallbackGoBackPath } = props;
  const verifyOtpModalState = useModalState();
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const worker = useDefinedWorker();
  const { phone } = worker;

  const { identityProvider, requestOtp } = useStepUpAuthContext();

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader
        title={title}
        scrollContainerRef={scrollContainerRef}
        headerVariant="tertiary"
        fallbackGoBackPath={fallbackGoBackPath}
        onClickBack={onCancel}
      />

      <Stack
        ref={scrollContainerRef}
        sx={{ flexDirection: "column", padding: 5, flex: 1, gap: 4, overflow: "auto" }}
      >
        <StepUpAuthConfirmationText phoneNumber={phone} />
      </Stack>

      <PageFooterWrapper>
        <StepUpAuthRequestOtpButton
          phoneNumber={phone}
          eventName={requestOtpEventName}
          onSuccess={() => {
            verifyOtpModalState.openModal();
          }}
        />
      </PageFooterWrapper>

      <VerifyOtpDialog
        modalState={verifyOtpModalState}
        phoneNumber={phone}
        authMode={AuthMode.AD_HOC}
        identityProvider={identityProvider}
        resendOtp={requestOtp}
        onSuccess={async () => {
          verifyOtpModalState.closeModal();
          onSuccess();
        }}
      />
    </PageWrapper>
  );
}
